<template>
    <div component="ProjectActorDialogPortfolio">
        <h3>Portfolio:</h3>
        <div class="scroll">
            <div v-bar class="vb">
                <div>
                    <div class="empty" v-if="!portfolioAudio.length">
                        This actor has not uploaded any audio recordings.
                    </div>
                    <div class="item" v-for="sample in portfolioAudio" :key="sample.id">
                        <mp3-player
                            :state="!sample.file_id ? 'error' : ''"
                            class="sample"
                            :file="getActorFileUrl(sample.file_id)"
                            :size="'small'"
                            :visualizer="'project'"
                        ></mp3-player>
                        <div class="name" :title="sample.nazov">
                            <div class="text">
                                {{ sample.nazov }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Mp3Player from '@/components/.global/Mp3Player';

export default {
    name: 'ProjectActorDialogPortfolio',

    components: { Mp3Player },

    props: {
        actor: {
            type: Object,
            required: true,
        },
    },

    computed: {
        ...mapGetters(['getActorFileUrl']),

        portfolioAudio() {
            return this.actor.portfolio.filter((item) => item.file_type == 'audio' && item.state == 'ready');
        },
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='ProjectActorDialogPortfolio'] {
    height: 0;
    flex-grow: 1;
    padding: 25px 0;
    width: 100%;

    h3 {
        margin-top: 0;
    }

    .scroll {
        min-height: 190px;
        height: 100%;
        overflow-y: auto;
    }

    h3 {
        margin-bottom: 5px;
    }

    .empty {
        font-size: 13px;
        color: fade(black, 50%);
    }

    .item {
        .flex-row;
        justify-content: flex-start;
        padding: 3px 0;
        .border-b;
        margin-right: 15px;

        .name {
            margin-left: 5px;
            font-weight: bold;
            overflow: hidden;

            .text {
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
    }
}
</style>
